import api from "./axiosConfig";

// Fetch a single blog by ID
export const getBlogById = async (id) => {
  try {
    const response = await api.get(`blogsingle/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching blog:", error);
    return null;
  }
};
